/*
 * @Description:
 * @Date: 2025-06-13 10:13:28
 */

export const notInvoicedListTranslator = resp => {
  resp.data.list = resp.data.list.map(item => {
    return {
      ...item,
      _id: `${item.openOrderId}_${item.userDefinedOrderId}`,
      _selections: []
    };
  });
  return resp;
};
export const contentOfMakeOutAnInvoiceTranslator = resp => {
  resp.data.list = resp.data.list.map(item => {
    return {
      ...item,
      _items: []
    };
  });
  return resp;
};
export const listSelectEnterpriseTranslator = resp => {
  resp.data = resp.data.map(item => {
    return {
      ...item,
      industryId: +item.industryId
    };
  });
  return resp;
};
/**
 * @description: 添加自定义字段，用于区分选择器所选择的数据是企业还是个体
 */
export const listSupplierTranslator = resp => {
  resp.data = resp.data.map(item => {
    return {
      ...item,
      _fId: `${item.id}_${item.type}`
    };
  });
  return resp;
};
/**
 * @description: 根据自定义字段映射提交的参数
 */
export const queryInvoiceListParamsTranslator = params => {
  if (params._fId) {
    const KEY = {
      1: 'supplierId',
      2: 'individualId'
    };
    const [id, type] = params._fId.split('_');
    params[KEY[type]] = id;
  }
  return params;
};
export const recognitiontranslator = resp => {
  if (resp.data?.invoiceDate) {
    resp.data.invoiceDate = resp.data.invoiceDate.replace(/年|月/g, '-');
    resp.data.invoiceDate = resp.data.invoiceDate.replace(/日/g, '');
  }
  return resp;
};
